import { object } from 'yup';
import { confirmPasswordSchema, passwordSchema } from '../Landing/helpers/validation';

export default object({
  password: passwordSchema,
  passwordConfirmation: confirmPasswordSchema
});
